<rds-breadcrumbs size="l" [items]="items()" (itemClick)="navigate($event)"></rds-breadcrumbs>
